export default "__VITE_ASSET__BAKj$NIO__"